export default __webpack_public_path__ + "static/media/dancing-script-latin-500.73b6a418.woff";